import React, { useEffect, useState } from "react";
import Header from "components/Headers/Header";
import { get, post, put } from "utils/api";

const DEDUCT_ROLES = ["relo", "tenant"];

const BookingCharges = () => {
  const [roleList, setRoleList] = useState([]);
  const [roleData, setRoleData] = useState({});
  const [loading, setLoading] = useState(false);

  /* =======================
     Initial Load
  ======================= */
  useEffect(() => {
    const init = async () => {
      const roleRes = await get("/api/roles/get-list");
      const roles = roleRes?.data || [];
      setRoleList(roles);

      const chargeRes = await get("/api/admin/get/booking-charges");
      const charges = chargeRes?.data || [];

      const state = {};

      roles.forEach((role) => {
        const match = charges.find((c) => Number(c.role) === Number(role.id));
        // const isDeduct = DEDUCT_ROLES.includes(role.name);
        const isDeduct = true;

        state[role.id] = {
          id: match ? match.id : null,
          percentage: match ? match.percentage : "",
          adjustment_type: isDeduct ? "DEDUCT" : "ADD",
        };
        // state[role.id] = {
        //   id: match ? match.id : null,
        //   percentage: match ? match.percentage : "",
        //   adjustment_type: match ? match.adjustment_type : "DEDUCT",
        // };
      });

      setRoleData(state);
    };

    init();
  }, []);

  /* =======================
     Input Change
  ======================= */
  const handleChange = (roleId, value) => {
    setRoleData((prev) => ({
      ...prev,
      [roleId]: {
        ...prev[roleId],
        percentage: value,
      },
    }));
  };

  /* =======================
     Save / Update
  ======================= */
  const handleSubmit = async (roleId) => {
    const data = roleData[roleId];

    if (!data.percentage) {
      alert("Percentage is required");
      return;
    }

    const payload = {
      role: roleId,
      percentage: Number(data.percentage),
      adjustment_type: 'DEDUCT',
    };

    try {
      setLoading(true);

      if (data.id) {
        await put(`/api/admin/edit/booking-charges/${data.id}`, payload);
      } else {
        await post("/api/admin/add/booking-charges", payload);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className="container mt-4">
        <h3 className="mr-auto">Booking Charges</h3>

        <div className="card p-3 mb-3">
          {roleList
            .filter((role) => role.name !== "furniture_company")
            .map((role) => {
              const data = roleData[role.id];
              if (!data) return null;

              return (
                <div key={role.id} className="mb-4">
                  <h5 className="text-capitalize fs-5 fw-bold">{role.name.replace(/_/g, " ")}</h5>

                  <div className="row mt-3 align-items-end">
                    {/* Percentage */}
                    <div className="col-md-10">
                      <label>Percentage   <i
                          title={`Booking fees (${data?.percentage}%) will be deducted from the ${role.name.replace(/_/g, " ")} fees.`}
                          class="fa-solid fa-circle-info"
                          style={{ color: "#0474ba" }}
                        ></i> *</label>
                      <div className="input-group">
                        <input
                          type="number"
                          className="form-control"
                          min={0}
                          max={100}
                          value={data.percentage}
                          onChange={(e) =>
                            handleChange(role.id, e.target.value)
                          }
                        />
                        <span className="input-group-text">%</span>
                      </div>
                    </div>

                    {/* Adjustment Type (Read-only) */}
                    {/* <div className="col-md-6">
                      <label>Adjustment</label>
                      <div>
                        <input
                          type="text"
                          className="form-control"
                          min={0}
                          max={100}
                          value={`booking fees will be deducted from ${role.name.replace(/_/g, " ")} fees (${data?.percentage}%).`}
                          readOnly
                        />
                      </div>
                    </div> */}

                    {/* Save */}
                    <div className="col-md-2">
                      <button
                        className="btn"
                        style={{
                          backgroundColor: "#0474ba",
                          color: "#fff",
                        }}
                        disabled={loading}
                        onClick={() => handleSubmit(role.id)}
                      >
                        {data.id ? "Update" : "Save"}
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default BookingCharges;
